<template>
  <div class="this-navbar" v-bind:class="{'top': !onTop}">
    <Logo v-if="!onTop" height="60" padding="5,5,5,5" :one-line="false" :light-theme="!onTop"></Logo>
    <div class="dropdown pi pi-bars" v-on:click="toggleMenu">
    </div>
    <menu v-bind:class="{'hide': hideMenu}">
      <div class="links" v-on:click="closeMenu">
        <a class="link" v-bind:class="{'active': current === 'home'}" href="#home">{{ $t('links.home')}}</a>
        <a class="link" v-bind:class="{'active': current === 'profile'}" href="#profile">{{ $t('links.profile')}}</a>
        <a class="link" v-bind:class="{'active': current === 'services'}" href="#services">{{ $t('links.services')}}</a>
        <a class="link" v-bind:class="{'active': current === 'skills'}" href="#skills">{{ $t('links.skills')}}</a>
        <a class="link" v-bind:class="{'active': current === 'resume'}" href="#resume">{{ $t('links.resume')}}</a>
        <a class="link" v-bind:class="{'active': current === 'contact'}" href="#contact">{{ $t('links.contact')}}</a>
        <a v-if="false" class="link" to="/quotationGenerator">{{ $t('links.quotationGenerator')}}</a>
        <a v-if="false"  class="link" to="/table">{{ $t('links.crud')}}</a>
      </div>
      <div class="locale-changer">
        <div v-if="!displayChanger" v-on:click="displayLocaleChanger">
          <img :alt="$i18n.locale + ' locale'" v-bind:src="require('../assets/img/flags/' + $i18n.locale + '.jpg')" />
        </div>
        <div v-if="displayChanger">
          <div v-bind:key="locale" v-for="locale in langs">
            <img :alt="locale + ' locale'" v-bind:src="require('../assets/img/flags/' + locale + '.jpg')"
                 v-on:click="changeLocale(locale)" />
          </div>
        </div>
      </div>
    </menu>
  </div>
</template>

<script>
    import Logo from './logo';
export default {
  name: 'NavBar',
  components: {
    Logo
  },
  props: {onTop: Boolean, current: String},
  methods: {
    displayLocaleChanger: function () {
      this.displayChanger = true;
    },
    toggleMenu: function () {
      this.hideMenu = !this.hideMenu;
    },
    closeMenu: function () {
      this.hideMenu = true;
    },
    changeLocale: function (locale) {
      this.displayChanger = false;
      this.hideMenu = true;
      this.$i18n.locale = locale;
    },
  },
  data: () => {
    return {
      hideMenu: true,
      langs: ['fr', 'en'],
      displayChanger: false,
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import 'src/assets/styles/variables';

  .this-navbar {
    width: 100vw;
    display: flex;
    justify-content: flex-end;
  }

  @media (min-width: 640px) {
    .this-navbar {
      padding: 50px;
      font-size: 20px;
      transition: background-color 1s, padding 1s;

      &.top {
        justify-content: space-between;
        background-color: $secondaryColor;
        padding: 20px;
        transition: background-color 1s, padding 1s;
      }

      menu {
        display: flex;

        .links {
          display: flex;
          text-transform: uppercase;
          margin-right: 70px;
          align-items: center;
          flex-wrap: wrap;

          a {
            color: white;
            text-decoration: none;
            padding: 0 20px;
          }
          a.active {
            color: $mainColor;
          }
        }
        .locale-changer {
          width: 70px;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 50px;

          img {
            height: 30px;
          }
        }
      }
      .dropdown {
        display: none;
      }
    }
  }

  @media (max-width: 640px) {
    .this-navbar {
      padding: 5px;
      background-color: $secondaryColor;
      justify-content: flex-end;

      &.top {
        justify-content: space-between;
      }

      .hide {
        display: none!important;
      }

      .dropdown {
        display: block;
        height: 50px;
        padding: 10px;
        font-size: 30px;
        color: $mainColor;
      }

      menu {
        z-index: 10;
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 60px;
        right: 0;
        background-color: $mainColor;
        border-radius: 0 0 0 5px;

        .links {
          display: flex;
          flex-direction: column;
          a {
            color: $secondaryColor;
            text-decoration: none;
            padding: 10px 20px;
            line-height: 30px;
          }
          a.router-link-exact-active {
            font-weight: bold;
            text-decoration: underline;
          }
        }
        .locale-changer {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 50px;
          top: 30px;
          right: 10px;

          img {
            height: 30px;
          }
        }
      }
    }
  }
</style>
